import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import Home from './pages/Home.jsx'
import PollPage from './pages/PollPage.jsx'
import { PrivacyPage } from './pages/PrivacyPage.jsx'
import { TermsPage } from './pages/TermsPage.jsx'

// UX59: embed routes code-split so the publisher iframe payload stays
// lean and the main-app bundle isn't bloated by UI nobody-logged-in
// will see.
const EmbedPollPage    = lazy(() => import('./pages/embed/EmbedPollPage.jsx'))
const EmbedTallyPage   = lazy(() => import('./pages/embed/EmbedTallyPage.jsx'))
const EmbedFeedPage    = lazy(() => import('./pages/embed/EmbedFeedPage.jsx'))
const EmbedCatalogPage = lazy(() => import('./pages/EmbedCatalogPage.jsx'))

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/poll/:id" element={<PollPage />} />
        <Route path="/bill/:slug" element={<PollPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        {/* UX59 */}
        <Route path="/embed" element={<Suspense fallback={null}><EmbedCatalogPage /></Suspense>} />
        <Route path="/embed/poll/:idOrSlug" element={<Suspense fallback={null}><EmbedPollPage /></Suspense>} />
        <Route path="/embed/tally/:idOrSlug" element={<Suspense fallback={null}><EmbedTallyPage /></Suspense>} />
        <Route path="/embed/feed/:jurisdiction" element={<Suspense fallback={null}><EmbedFeedPage /></Suspense>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Analytics />
    </>
  )
}
